import { render, staticRenderFns } from "./magicCube.vue?vue&type=template&id=1b1c7266&scoped=true&"
import script from "./magicCube.vue?vue&type=script&lang=js&"
export * from "./magicCube.vue?vue&type=script&lang=js&"
import style0 from "./magicCube.vue?vue&type=style&index=0&id=1b1c7266&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c7266",
  null
  
)

export default component.exports